// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"tagLabel_mulitpleDropdown__ca2eO","label":"tagLabel_label__1LOes"};